import { Link, Tag, Tooltip } from '@lego/klik-ui';
import type { MouseEvent } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useFleet } from '@/hooks/fleet/fleet_resource';
import { paths } from '@/utility/global_paths';

type Props = {
  fleetId: number;
  workspaceId: number;
  isCohosted?: boolean;
};

type FleetNameBadgeProps = Props & {
  name: string;
  isLoading?: boolean;
};

export const FleetBadge = ({ fleetId, workspaceId, isCohosted = false }: Props) => {
  const { data, isLoading } = useFleet(workspaceId, fleetId);

  return (
    <FleetNameBadge
      fleetId={fleetId}
      isCohosted={isCohosted}
      isLoading={isLoading}
      name={data?.name ?? String(fleetId)}
      workspaceId={workspaceId}
    />
  );
};

export const FleetNameBadge = ({
  fleetId,
  workspaceId,
  isCohosted = false,
  name,
  isLoading = false,
}: FleetNameBadgeProps) => {
  return (
    <Tooltip
      key={fleetId}
      label={`${name} | Workspace ID: ${workspaceId} | Fleet ID: ${fleetId} ${isCohosted ? '(cohosted)' : ''}`}
    >
      <Link
        as={ReactRouterLink}
        data-interactive
        minWidth={0}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
        p={0}
        to={paths.fleetById(workspaceId, fleetId)}
      >
        <Tag maxWidth="100%" variant={isLoading ? 'subtle' : 'plain'}>
          <Tag.Label minWidth={0}>
            <span
              style={{
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {name}
            </span>
          </Tag.Label>
        </Tag>
      </Link>
    </Tooltip>
  );
};
